// import React from 'react';
import { useToastState } from '../store/useAppStore';

export default function HelpPage() {
  const { showToast } = useToastState();
  return (
    <div className="min-h-screen wa-gradient-bg" style={{ padding: 'var(--wa-space-8)' }}>
      <div className="wa-card wa-card-body" style={{ maxWidth: '48rem', margin: '0 auto' }}>
        <header style={{ marginBottom: 'var(--wa-space-8)', textAlign: 'center' }}>
          <div 
            className="wa-gradient-yellow-primary flex items-center justify-center mx-auto"
            style={{ 
              width: 'var(--wa-space-16)', 
              height: 'var(--wa-space-16)', 
              borderRadius: 'var(--wa-rounded-full)',
              marginBottom: 'var(--wa-space-4)',
              border: '2px solid var(--wa-yellow-400)',
              boxShadow: '0 4px 15px rgba(255, 193, 7, 0.3)'
            }}
          >
            <span style={{ fontSize: 'var(--wa-text-2xl)', color: 'var(--wa-yellow-900)' }}>❓</span>
          </div>
          <h1 className="wa-heading-2" style={{ marginBottom: 'var(--wa-space-2)' }}>
            Como Usar o Whats Automation
          </h1>
          <p className="wa-body-small" style={{ color: 'var(--wa-gray-600)' }}>
            Guia completo para usar todas as funcionalidades
          </p>
        </header>
        {/* Envio para Grupos */}
        <section style={{ marginBottom: 'var(--wa-space-8)' }}>
          <div 
            style={{ 
              padding: 'var(--wa-space-6)',
              backgroundColor: 'var(--wa-yellow-50)',
              border: `2px solid var(--wa-yellow-200)`,
              borderRadius: 'var(--wa-rounded-xl)',
              marginBottom: 'var(--wa-space-6)'
            }}
          >
            <h2 className="wa-heading-4 flex items-center" style={{ gap: 'var(--wa-space-3)', marginBottom: 'var(--wa-space-4)', color: 'var(--wa-yellow-800)' }}>
              <span style={{ fontSize: 'var(--wa-text-lg)' }}>👥</span> Envio para Grupos
            </h2>
            <ol style={{ paddingLeft: 'var(--wa-space-6)', margin: 0, display: 'flex', flexDirection: 'column', gap: 'var(--wa-space-3)' }}>
              <li className="wa-body-default" style={{ color: 'var(--wa-gray-700)' }}>
                <strong style={{ color: 'var(--wa-yellow-700)' }}>Conecte seu WhatsApp:</strong> Escaneie o QR Code na tela inicial com o app do WhatsApp no seu celular.
              </li>
              <li className="wa-body-default" style={{ color: 'var(--wa-gray-700)' }}>
                <strong style={{ color: 'var(--wa-yellow-700)' }}>Escolha os grupos:</strong> Use a busca para encontrar e marcar os grupos desejados.
              </li>
              <li className="wa-body-default" style={{ color: 'var(--wa-gray-700)' }}>
                <strong style={{ color: 'var(--wa-yellow-700)' }}>Monte sua mensagem:</strong> Digite o texto, adicione PDF ou áudio (.ogg) e organize a ordem de envio.
              </li>
              <li className="wa-body-default" style={{ color: 'var(--wa-gray-700)' }}>
                <strong style={{ color: 'var(--wa-yellow-700)' }}>Envie:</strong> Clique em{' '}
                <span 
                  style={{ 
                    background: 'var(--wa-gradient-yellow-primary)',
                    color: 'var(--wa-yellow-900)',
                    padding: 'var(--wa-space-1) var(--wa-space-3)',
                    borderRadius: 'var(--wa-rounded-md)',
                    fontSize: 'var(--wa-text-sm)',
                    fontWeight: 'var(--wa-font-semibold)'
                  }}
                >
                  Enviar
                </span>{' '}
                e acompanhe o progresso.
              </li>
            </ol>
            <div 
              style={{ 
                marginTop: 'var(--wa-space-4)',
                padding: 'var(--wa-space-3)',
                backgroundColor: 'var(--wa-yellow-100)',
                borderRadius: 'var(--wa-rounded-lg)'
              }}
            >
              <p className="wa-body-small" style={{ color: 'var(--wa-yellow-800)', margin: 0 }}>
                <strong>💡 Dicas:</strong> Áudios devem ser <strong>.ogg</strong> (áudio de voz do WhatsApp). Documentos devem ser <strong>.pdf</strong>.
              </p>
            </div>
          </div>
        </section>
        {/* Envio em Massa */}
        <section style={{ marginBottom: 'var(--wa-space-8)' }}>
          <div 
            style={{ 
              padding: 'var(--wa-space-6)',
              backgroundColor: 'var(--wa-gold-50)',
              border: `2px solid var(--wa-gold-200)`,
              borderRadius: 'var(--wa-rounded-xl)',
              marginBottom: 'var(--wa-space-6)'
            }}
          >
            <h2 className="wa-heading-4 flex items-center" style={{ gap: 'var(--wa-space-3)', marginBottom: 'var(--wa-space-4)', color: 'var(--wa-gold-800)' }}>
              <span style={{ fontSize: 'var(--wa-text-lg)' }}>📦</span> Envio em Massa
            </h2>
            <ol style={{ paddingLeft: 'var(--wa-space-6)', margin: 0, display: 'flex', flexDirection: 'column', gap: 'var(--wa-space-3)' }}>
              <li className="wa-body-default" style={{ color: 'var(--wa-gray-700)' }}>
                <strong style={{ color: 'var(--wa-gold-700)' }}>Conecte seu WhatsApp:</strong> Escaneie o QR Code na tela inicial.
              </li>
              <li className="wa-body-default" style={{ color: 'var(--wa-gray-700)' }}>
                <strong style={{ color: 'var(--wa-gold-700)' }}>Adicione os números:</strong> Cole ou envie um arquivo com os números de telefone (um por linha, com DDD).
              </li>
              <li className="wa-body-default" style={{ color: 'var(--wa-gray-700)' }}>
                <strong style={{ color: 'var(--wa-gold-700)' }}>Escreva sua mensagem:</strong> Digite o texto que será enviado para todos os números.
              </li>
              <li className="wa-body-default" style={{ color: 'var(--wa-gray-700)' }}>
                <strong style={{ color: 'var(--wa-gold-700)' }}>Envie:</strong> Clique em{' '}
                <span 
                  style={{ 
                    background: 'var(--wa-gradient-yellow-primary)',
                    color: 'var(--wa-yellow-900)',
                    padding: 'var(--wa-space-1) var(--wa-space-3)',
                    borderRadius: 'var(--wa-rounded-md)',
                    fontSize: 'var(--wa-text-sm)',
                    fontWeight: 'var(--wa-font-semibold)'
                  }}
                >
                  Enviar
                </span>{' '}
                e acompanhe o progresso.
              </li>
            </ol>
            <div 
              style={{ 
                marginTop: 'var(--wa-space-4)',
                padding: 'var(--wa-space-3)',
                backgroundColor: 'var(--wa-gold-100)',
                borderRadius: 'var(--wa-rounded-lg)'
              }}
            >
              <p className="wa-body-small" style={{ color: 'var(--wa-gold-800)', margin: 0 }}>
                <strong>💡 Dicas:</strong> Use apenas números válidos. Você pode acompanhar o resultado e ver quais números receberam a mensagem.
              </p>
            </div>
          </div>
        </section>

        {/* Sistema de Notificações */}
        <section style={{ marginBottom: 'var(--wa-space-8)' }}>
          <div 
            style={{ 
              padding: 'var(--wa-space-6)',
              backgroundColor: 'var(--wa-blue-50)',
              border: `2px solid var(--wa-blue-200)`,
              borderRadius: 'var(--wa-rounded-xl)',
              marginBottom: 'var(--wa-space-6)'
            }}
          >
            <h2 className="wa-heading-4 flex items-center" style={{ gap: 'var(--wa-space-3)', marginBottom: 'var(--wa-space-4)', color: 'var(--wa-blue-800)' }}>
              <span style={{ fontSize: 'var(--wa-text-lg)' }}>🔔</span> Sistema de Notificações
            </h2>
            <p className="wa-body-default" style={{ color: 'var(--wa-gray-700)', marginBottom: 'var(--wa-space-4)' }}>
              Teste o novo sistema de notificações melhorado! As notificações agora aparecem acima da navbar e possuem animações suaves.
            </p>
            
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 'var(--wa-space-3)' }}>
              <button
                onClick={() => showToast({
                  type: 'success',
                  title: 'Sucesso!',
                  message: 'Operação concluída com sucesso.',
                  duration: 4000
                })}
                className="wa-btn wa-transition-colors"
                style={{
                  padding: 'var(--wa-space-3) var(--wa-space-4)',
                  backgroundColor: 'var(--wa-success-100)',
                  color: 'var(--wa-success-800)',
                  border: '2px solid var(--wa-success-300)',
                  borderRadius: 'var(--wa-rounded-lg)',
                  fontSize: 'var(--wa-text-sm)',
                  fontWeight: 'var(--wa-font-semibold)',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 'var(--wa-space-2)',
                  justifyContent: 'center'
                }}
              >
                <span>✅</span> Toast Sucesso
              </button>

              <button
                onClick={() => showToast({
                  type: 'error',
                  title: 'Erro!',
                  message: 'Algo deu errado. Tente novamente.',
                  duration: 5000
                })}
                className="wa-btn wa-transition-colors"
                style={{
                  padding: 'var(--wa-space-3) var(--wa-space-4)',
                  backgroundColor: 'var(--wa-error-100)',
                  color: 'var(--wa-error-800)',
                  border: '2px solid var(--wa-error-300)',
                  borderRadius: 'var(--wa-rounded-lg)',
                  fontSize: 'var(--wa-text-sm)',
                  fontWeight: 'var(--wa-font-semibold)',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 'var(--wa-space-2)',
                  justifyContent: 'center'
                }}
              >
                <span>❌</span> Toast Erro
              </button>

              <button
                onClick={() => showToast({
                  type: 'warning',
                  title: 'Atenção!',
                  message: 'Verifique suas configurações.',
                  duration: 4000
                })}
                className="wa-btn wa-transition-colors"
                style={{
                  padding: 'var(--wa-space-3) var(--wa-space-4)',
                  backgroundColor: 'var(--wa-warning-100)',
                  color: 'var(--wa-warning-800)',
                  border: '2px solid var(--wa-warning-300)',
                  borderRadius: 'var(--wa-rounded-lg)',
                  fontSize: 'var(--wa-text-sm)',
                  fontWeight: 'var(--wa-font-semibold)',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 'var(--wa-space-2)',
                  justifyContent: 'center'
                }}
              >
                <span>⚠️</span> Toast Aviso
              </button>

              <button
                onClick={() => showToast({
                  type: 'info',
                  title: 'Informação',
                  message: 'Nova funcionalidade disponível!',
                  duration: 4000,
                  action: {
                    label: 'Ver mais',
                    onClick: () => showToast({
                      type: 'success',
                      title: 'Ação executada!',
                      message: 'Você clicou no botão de ação.',
                      duration: 3000
                    })
                  }
                })}
                className="wa-btn wa-transition-colors"
                style={{
                  padding: 'var(--wa-space-3) var(--wa-space-4)',
                  backgroundColor: 'var(--wa-blue-100)',
                  color: 'var(--wa-blue-800)',
                  border: '2px solid var(--wa-blue-300)',
                  borderRadius: 'var(--wa-rounded-lg)',
                  fontSize: 'var(--wa-text-sm)',
                  fontWeight: 'var(--wa-font-semibold)',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 'var(--wa-space-2)',
                  justifyContent: 'center'
                }}
              >
                <span>ℹ️</span> Toast Ação
              </button>
            </div>

            <div 
              style={{ 
                marginTop: 'var(--wa-space-4)',
                padding: 'var(--wa-space-3)',
                backgroundColor: 'var(--wa-blue-100)',
                borderRadius: 'var(--wa-rounded-lg)'
              }}
            >
              <p className="wa-body-small" style={{ color: 'var(--wa-blue-800)', margin: 0 }}>
                <strong>✨ Melhorias:</strong> Agora as notificações ficam sempre visíveis acima da navbar, possuem animações suaves e responsividade mobile.
              </p>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer 
          style={{ 
            marginTop: 'var(--wa-space-8)',
            padding: 'var(--wa-space-4)',
            textAlign: 'center',
            backgroundColor: 'var(--wa-yellow-25)',
            borderRadius: 'var(--wa-rounded-xl)',
            border: `1px solid var(--wa-yellow-200)`
          }}
        >
          <p className="wa-body-small" style={{ color: 'var(--wa-gray-600)', margin: 0 }}>
            Qualquer dúvida, entre em contato com o suporte do sistema.
          </p>
        </footer>
      </div>
    </div>
  );
} 